"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowRunAccessor = exports.FlowRunsAccessor = void 0;
const _1 = require(".");
const errors_1 = require("../errors");
const flows_1 = require("../flows");
class FlowRunsAccessor {
    constructor(client) {
        this.client = client;
    }
    async find(query) {
        return this.client.get('/flow-runs', query);
    }
    async create(request) {
        return this.client.post('/flow-runs', request);
    }
}
exports.FlowRunsAccessor = FlowRunsAccessor;
class FlowRunAccessor {
    constructor(client, id) {
        this.client = client;
        this.id = id;
        this.baseUri = `/flow-runs/${id}`;
    }
    async get() {
        return this.client.get(this.baseUri);
    }
    async stop() {
        await this.client.post(`${this.baseUri}/stop`);
    }
    async getOutput() {
        return this.client.get(`${this.baseUri}/output`);
    }
    async repeat() {
        const flowRun = await this.get();
        if (flowRun.state === _1.FlowRunState.RUNNING) {
            throw new errors_1.BadRequestError('Cannot repeat a running flow run.');
        }
        const flowInstanceAccessor = new flows_1.FlowInstanceAccessor(this.client, flowRun.flowInstanceId);
        return flowInstanceAccessor.startRun({
            nodeKey: flowRun.startNodeKey,
            input: flowRun.input,
        });
    }
}
exports.FlowRunAccessor = FlowRunAccessor;
//# sourceMappingURL=accessors.js.map